import React from 'react';
import AppRouter from './AppRouter';
import store from './store';
import theme from './theme/theme';
import LoadingBar from './theme/components/LoadingBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GivelifyThemeProvider } from '@givelify/ui';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './translations/i18n';
import { FullStory } from 'utils/FullStory';

class CustomString extends String {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    charAt(_: number): any {
        return {
            toUpperCase: () => this.valueOf(),
        };
    }
}

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const customWeekDays = weekDays.map((day) => new CustomString(day) as string);

class DateAdapter extends AdapterDayjs {
    getWeekdays = (): string[] => customWeekDays;
}

export const ThemeApp: React.FCC = ({ children }) => (
    <React.Suspense fallback={<LoadingBar show />}>
        <Provider store={store}>
            <FullStory />
            <MuiThemeProvider theme={theme}>
                <GivelifyThemeProvider>
                    <LocalizationProvider dateAdapter={DateAdapter}>
                        <CssBaseline />
                        {children}
                    </LocalizationProvider>
                </GivelifyThemeProvider>
            </MuiThemeProvider>
        </Provider>
    </React.Suspense>
);

export const RouterApp = () => (
    <BrowserRouter>
        <AppRouter />
    </BrowserRouter>
);
